// Mux playback ids for the videos that aren't attached to a record
export const ABOUT_RIPARIDE_PLAYBACK_ID =
  'UH02jGbwID97FzihEbiTsiE00iwjyT4hmNbz448IzFYSE'
export const CALENDAR_SYNC_HELP_PLAYBACK_ID =
  '1gMI2GwI3Si8100B00I3mCwnN3O7SdofSy9801PeKV437Q'
